import classNames from "classnames";
import PropTypes from "prop-types";

export const Heading3 = ({ children, classes }) => {
  return <h3 className={classNames(classes, "heading-h3")}>{children}</h3>;
};

Heading3.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
